import React, {
  useContext,
  useCallback,
  useMemo,
  useEffect,
  useState,
} from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  TextField,
  Grid,
  InputAdornment,
  Pagination,
  Stack,
  Backdrop,
  useTheme,
  Typography,
  MenuItem,
  Divider,
  ListItemButton,
} from "@mui/material";
import dayjs from "dayjs";
import DownloadIcon from "@mui/icons-material/Download";
import { useLocation, useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { PAGE_SIZE } from "../../Services/common/const";
import Title from "../../Components/Title";
import ShortcutButton from "../../Components/ShortcutButton";
import { PreferencesContext } from "../../PreferencesContext";
import MissingConsumer from "../../Components/MissingConsumer";
import {
  ExportFilesFunction,
  numberFormat,
  useQuery,
} from "../../shared/CommonFuctions";
import { KeyboardArrowDownSharp } from "@mui/icons-material";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { DateRange } from "react-date-range";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import SplashComponent from "../../Navigation/splash";
import { AlertType } from "../../shared/Modal/AlertType";
import { EncryptDecryptService } from "../../Services/common/EncryptionService";
import { StyledMenu } from "../../Components/StyleMenus";
import { format } from "date-fns";
import CustomDateRangePicker from "../../Components/CustomDateRange";
import { GetWarehouseList } from "../../Services/WarehouseService";
import MultiSelectSim from "../../Components/MultiSelectSimple";
import { DateRangeIcon } from "@mui/x-date-pickers";
import {
  usePopupState,
  bindTrigger,
  bindMenu,
} from "material-ui-popup-state/hooks";
import MultiSelect from "../../Components/MultiSelect";
import DateRangePopup from "../../Components/DateRangePopup";
import { GetChallanDueSummaryReport } from "../../Services/ReportService";
import { GetProductList } from "../../Services/CategoryProductService";
import { GetBuyerList } from "../../Services/BuyerService";
import { parametersForSalePage } from "../../StaticData/common";
import { GetChallanDueSummaryList } from "../../Services/ChallanService";

const parameters = {
  consumerId: 25,
  branchId: 1,
  pageIndex: 1,
  productIds: "",
  buyerIds: "",
  pageSize: PAGE_SIZE,
  sortColumn: "",
  sortDirection: "",
  searchValue: "",
  lessThanValue: "",
};

type Order = "asc" | "desc" | "";

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

interface EnhancedTableProps {
  order: Order;
  orderBy: String;
  rowCount: number;
}

export default function ChallanDueSummaryByProduct() {
  const popupState = usePopupState({ variant: "popover", popupId: "demoMenu" });
  const theme = useTheme();
  const navigate = useNavigate();
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const [isLoading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [param, setParam] = useState(parameters);
  const [fromDate, setFromDate] = useState<any>(
    userContext.financialYearStartDate
  );
  const [toDate, setToDate] = useState<any>(userContext.financialYearEndDate);
  const [order, setOrder] = useState<Order>("");
  const [warehouseList, setWarehouseList] = React.useState(
    userContext.warehouseColl || []
  );
  const [orderBy, setOrderBy] = useState<keyof Data>("none");
  const [resultData, setResultData] = useState([]);
  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const matches = useMediaQuery("(max-width:425px)");
  const edService = new EncryptDecryptService();
  const openExportType = Boolean(anchorEl2);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(PAGE_SIZE);
  const [categorysSelectedOption, setCategorysSelectedOption] =
    React.useState<any>([]);
  const [selectedWarehouseId, setSelectedWarehouseId] = React.useState<any>([]);
  const [ProductCollection, setProductCollection] = useState<any>([]);
  const [CustomerCollection, setCustomerCollection] = useState<any>([]);
  const [productSelectedOption, setProductSelectedOption] = React.useState<any>(
    []
  );
  const [selectedProductIdData, setSelectedProductIdData] = React.useState<any>(
    []
  );
  const [customersSelectedOption, setCustomerssSelectedOption] =
    React.useState<any>([]);
  const [selectedCustomerIdData, setselectedCustomerIdData] =
    React.useState<any>([]);
  const [selectedWarehouseIdData, setSelectedWarehouseIdData] =
    React.useState<any>([]);
  const [selectedInvoiceSeriesType, setSelectedInvoiceSeriesType] =
    React.useState<any>([]);
  const [selectedInvoiceSeriesTypeData, setSelectedInvoiceSeriesTypeData] =
    React.useState<any>([]);
  const [challanStatusSummary, setChallanStatusSummary] = useState<any>(null);

  const [selectedIndex, setSelectedIndex] = React.useState(5);
  const [isCustomDate, setIsCustomDate] = React.useState(false);
  const [dateHeading, setDateHeading] = React.useState<any>(
    "Current financial year"
  );
  const [anchorE4, setAnchorEl4] = React.useState<HTMLButtonElement | null>(
    null
  );

  const [totalAmount, setTotalAmount] = useState({
    orderedQuantity: 0,
    orderedAmount: 0,
    balanceAmount: 0,
    usedQuantity: 0,
    balanceQuantity: 0,
  });

  const [popupAnchor, setPopupAnchor] = useState<HTMLElement | null>(null);
  const [tempFromDate, setTempFromDate] = useState<dayjs.Dayjs | null>(null);
  const [tempToDate, setTempToDate] = useState<dayjs.Dayjs | null>(null);
  const [dateError, setDateError] = useState<string | null>(null);
  const [selectedVoucherTypes, setSelectedVoucherTypes] = useState<string[]>(
    []
  );
  const handleVoucherTypeChange = (selectedValues: string[]) => {
    setSelectedVoucherTypes(selectedValues);
  };

  const location = useLocation();
  let urlParams = useQuery();
  const encryptedLabelId = urlParams.get("q");
  let decryptLabelId: any = edService.decrypt(encryptedLabelId);
  let convertedLabelId: any = parseInt(decryptLabelId) || 0;

  const pageInfo = useMemo(
    () => ({
      startIndex: (page - 1) * PAGE_SIZE + 1,
      endIndex: (page - 1) * PAGE_SIZE + resultData.length,
      totalPages: Math.ceil(totalCount / PAGE_SIZE),
    }),
    [page, resultData.length, totalCount]
  );

  const handlePageChange = useCallback(
    (event: React.ChangeEvent<unknown>, value: number) => {
      setPage(value);
      setParam((prev) => ({ ...prev, pageIndex: value }));
    },
    []
  );

  const startDate = new Date(userContext.financialYearStartDate);
  const endDate = new Date(userContext.financialYearEndDate);
  const [selectedDateRange, setDateRange] = useState<any>([
    {
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    },
  ]);

  const handleDateRange = (selected: any, popupState) => {
    // Your logic here
    const calenderHeading =
      format(new Date(selected[0].startDate), "dd-MM-yyyy") +
      " To " +
      format(new Date(selected[0].endDate), "dd-MM-yyyy");
    setDateRange(selected);
    setDateHeading(calenderHeading);
    popupState.close();
  };

  const handleMoveToChallanDueDetail = useCallback(
    async (productId: number) => {
      try {
        const encProductId = edService.encrypt(productId.toString());
        navigate({
          pathname: "/challan-due-detail-by-product",
          search: `?q=${encodeURIComponent(encProductId || "")}`,
        });
      } catch (e: any) {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: typeof e === "string" ? e : e?.message,
          alertType: AlertType.Error,
        });
      }
    },
    [navigate, edService, userContext, updateUserContext]
  );

  const handleChangeCategory = (object: any) => {
    setProductSelectedOption(object);
    let tempCustomerIdData: any = [];
    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let productId = x.productId;
        x.productId = productId;
        tempCustomerIdData.push(productId.toString());
      }
    });
    setSelectedProductIdData(tempCustomerIdData);
  };

  const handleChangeCategortwo = (object: any) => {
    setCustomerssSelectedOption(object);
    let tempCustomerIdData: any = [];
    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let buyerIds = x.buyerId;
        x.buyerId = buyerIds;
        tempCustomerIdData.push(buyerIds.toString());
      }
    });
    setselectedCustomerIdData(tempCustomerIdData);
  };

  async function fetchChallanDueSummaryList() {
    let params = new URLSearchParams();

    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("productIds", selectedProductIdData);
    params.append("buyerIds", selectedCustomerIdData);
    // params.append("startDate", format(new Date(fromDate), "yyyy-MM-dd"));
    // params.append("endDate", format(new Date(toDate), "yyyy-MM-dd"));
    params.append("pageIndex", page.toString());
    params.append("pageSize", PAGE_SIZE.toString());
    params.append("sortColumn", param.sortColumn);
    params.append("sortDirection", param.sortDirection);
    params.append("searchValue", searchValue ?? "");
    params.append("financialYear", userContext.financialYear.toString());
    try {
      setLoading(true);
      const result: any = await GetChallanDueSummaryList(params);

      if (result?.data?.data) {
        const dataBlock = result.data.data;
        setResultData(dataBlock.challanDueSummaryCollection ?? []);
        setTotalCount(dataBlock.totalCount ?? 0);

        setTotalAmount({
          orderedQuantity: dataBlock?.orderedQuantityTotal ?? 0,
          orderedAmount: dataBlock?.orderAmountTotal ?? 0,
          balanceAmount: dataBlock?.balanceAmountTotal ?? 0,
          usedQuantity: dataBlock?.usedQtyTotal ?? 0,
          balanceQuantity: dataBlock?.balanceQuantityTotal ?? 0,
        });
      } else {
        setResultData([]);
        setChallanStatusSummary([]);
        setTotalCount(0);
        setTotalAmount({
          orderedQuantity: 0,
          orderedAmount: 0,
          balanceAmount: 0,
          usedQuantity: 0,
          balanceQuantity: 0,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string"
            ? e
            : e?.message || "Error fetching sale order list",
        alertType: AlertType.Error,
      });
    } finally {
      setLoading(false);
    }
  }

  async function GetProductLists() {
    setLoading(true);
    let params = new URLSearchParams();
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("pageIndex", page.toString());
    params.append("pageSize", "5000");
    params.append("sortColumn", param.sortColumn);
    params.append("searchValue", param.searchValue);
    params.append("sortDirection", param.sortDirection);
    params.append("financialYear", userContext.financialYear.toString());

    try {
      let productCollection: any;
      const result: any = await GetProductList(params);
      if (result && result.data.data) {
        productCollection = result.data.data.productCollection;
        setProductCollection(productCollection);
      } else {
      }
      return productCollection;
    } catch (e:any) {
      setLoading(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  async function GetCustomerList() {
    setLoading(true);
    let params = new URLSearchParams();
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("pageIndex", parametersForSalePage.pageIndex.toString());
    params.append("pageSize", parametersForSalePage.pageSize.toString());
    params.append("sortColumn", parametersForSalePage.sortColumn);
    params.append("sortDirection", parametersForSalePage.sortDirection);
    params.append("financialYear", userContext.financialYear?.toString());

    try {
      let categoryInfo: any;
      const result: any = await GetBuyerList(params);
      if (result && result.data.data) {
        categoryInfo = result.data?.data?.buyerCollection;
        setCustomerCollection(categoryInfo);
      } else {
      }
      return categoryInfo;
    } catch (e:any) {
      setLoading(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  async function handelChallanDueReportPopup(type: string) {
    setAnchorEl2(null);
    setLoading(true);

    try {
      const params = new URLSearchParams();
      const attachmentName =
        type === "pdf"
          ? "ChallanDueSummaryByProductReport.pdf"
          : "ChallanDueSummaryByProductReport.xls";

      // Backend expects these parameters
      params.append("reportName", "ChallanDueSummaryByProductReport");
      params.append("reportType", type);
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("productIds", selectedProductIdData);
      params.append("buyerIds", selectedCustomerIdData);
      params.append("pageIndex", page.toString());
      params.append("pageSize", PAGE_SIZE.toString());
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", searchValue ?? "");
      params.append("financialYear", userContext.financialYear.toString());
      params.append("mode", "EXPORT");

      //  Call your backend API
      const result: any = await GetChallanDueSummaryReport(params);

      if (result?.data?.data?.fileData) {
        const fileContent = result.data.data.fileData;
        ExportFilesFunction(attachmentName, type, fileContent);
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: "No data found in report.",
          alertType: AlertType.Warning,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? e : e?.message || "Error generating report",
        alertType: AlertType.Error,
      });
    } finally {
      setLoading(false);
    }
  }

  const handleCloseExportType = () => {
    setAnchorEl2(null);
  };

  const handleClickExportType = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl2(event.currentTarget);
  };

  function EnhancedTableHead(props: EnhancedTableProps) {
    return (
      // checkBox for Header
      <TableHead>
        <TableRow>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="left">
            {"Product Name"}
          </TableCell>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="right">
            {"Ordered Qty"}
          </TableCell>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="right">
            {"Used Qty"}
          </TableCell>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="right">
            {"Balance Qty"}
          </TableCell>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="Right">
            {"Rate ₹"}
          </TableCell>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="right">
            {"Ordered Amount ₹"}
          </TableCell>

          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="right">
            {"Balance Amount ₹"}
          </TableCell>
        </TableRow>
      </TableHead>
    );
  }

  useEffect(() => {
    fetchChallanDueSummaryList();
    GetProductLists();
    GetCustomerList();
  }, [
    // selectedInvoiceSeriesTypeData,
    // selectedDateRange,
    fromDate,
    toDate,
    page,
    param.sortColumn,
    selectedProductIdData,
    selectedCustomerIdData,
    param.sortDirection,
    searchValue,
  ]);

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          backgroundColor: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}>
        <SplashComponent />
      </Backdrop>

      <Title pageTitle="Challan Due Summary By Products" />

      {userContext.consumerId > 0 ? (
        <Box
          className="boxContainer"
          sx={{
            "& > :not(style)": {
              width: "100%",
            },
          }}>
          {/* Header Section */}
          <Grid
            className="title-button-responsive"
            item
            xs={6}
            md={3}
            sx={{
              display: "flex !important",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <h4 className="page-title">Challan Due Summary By Products</h4>
            {matches && (
              <Box sx={{ marginLeft: 'auto' }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate(-1)}
                  size="medium"
                >
                  <ShortcutButton label="ESC" />
                  Back
                </Button>
              </Box>
            )}
            {!matches && (
              <>
                <Grid
                  item
                  xs={6}
                  md={3}
                  marginRight={0}
                  textAlign="end"
                  paddingTop="0px"
                >
                  <Box sx={{ display: "flex", gap: 2, alignItems: "end" }}>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Ordered Quantity</Typography>
                      <Box className={"inner-tabs tab-all"}>
                        {numberFormat(totalAmount?.orderedQuantity, 3, 3)}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Used Quantity</Typography>
                      <Box className={"inner-tabs tab-all"}>
                        {numberFormat(totalAmount?.usedQuantity, 3, 3)}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Balance Quantity</Typography>
                      <Box className={"inner-tabs tab-all"}>
                        {numberFormat(totalAmount?.balanceQuantity, 3, 3)}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Ordered Amount</Typography>
                      <Box className={"inner-tabs tab-all"}>
                        {numberFormat(totalAmount?.orderedAmount, 2, 2)}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Balance Amount</Typography>
                      <Box className={"inner-tabs tab-all"}>
                        {numberFormat(totalAmount?.balanceAmount, 2, 2)}
                      </Box>
                    </Box>
                    <Box>
                      <Button
                        // color="primary"
                        variant="outlined"
                        onClick={() => navigate(-1)}
                        size="medium"
                      >
                        <ShortcutButton label="ESC" />
                        Back
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </>
            )}
          </Grid>
          {matches && (
            <>
              <Grid item xs={12} md={3}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography>Ordered Quantity</Typography>
                    <Box className={"inner-tabs tab-all"}>
                      {numberFormat(totalAmount?.orderedQuantity, 3, 3)}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography>Used Quantity</Typography>
                    <Box className={"inner-tabs tab-all"}>
                      {numberFormat(totalAmount?.usedQuantity, 3, 3)}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography>Balance Quantity</Typography>
                    <Box className={"inner-tabs tab-all"}>
                      {numberFormat(totalAmount?.balanceQuantity, 3, 3)}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography>Ordered Amount</Typography>
                    <Box className={"inner-tabs tab-all"}>
                      {numberFormat(totalAmount?.orderedAmount, 2, 2)}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography>Balance Amount</Typography>
                    <Box className={"inner-tabs tab-all"}>
                      {numberFormat(totalAmount?.balanceAmount, 2, 2)}
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </>
          )}

          {/* Main Paper Section */}
          <Grid className="paper top-space">
            <Paper elevation={4} className="paper-container">
              {/* Search + Filters + Date + Export */}
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                spacing={2}
                className="search-space">
                {/* Search Field + Filters */}
                <Grid item xs={12} md={8}>
                  <Grid container alignItems="center" spacing={2}>
                    {/* MultiSelect Filters */}
                    <Grid item xs={12} sm={3} md={3}>
                      <MultiSelect
                        placeholderLabel="Products"
                        placeholder="Select Product.."
                        options={ProductCollection}
                        onChange={handleChangeCategory}
                        value={productSelectedOption}
                        isSelectAll={true}
                        menuPlacement={"bottom"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={9} md={9}>
                      <MultiSelect
                        placeholderLabel="Customers"
                        placeholder="Select Customer.."
                        options={CustomerCollection}
                        onChange={handleChangeCategortwo}
                        value={customersSelectedOption}
                        isSelectAll={true}
                        menuPlacement={"bottom"}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Date & Export Buttons */}
                <Grid item xs={12} md={4}>
                  <Grid
                    container
                    alignItems="center"
                    spacing={2}
                    justifyContent="flex-end">
                    {/* Date Range */}
                    <Grid item>
                      {/* <Box
                        display="flex"
                        gap={2}
                        justifyContent="end"
                        flexDirection={{
                          xs: "column",
                          sm: "row",
                        }}>
                        <CustomDateRangePicker
                          fromDate={fromDate}
                          setFromDate={setFromDate}
                          toDate={toDate}
                          setToDate={setToDate}
                        />
                      </Box> */}
                    </Grid>

                    {/* Export */}
                    <Grid item>
                      <Button
                        className="button-responsive-stock"
                        variant="outlined"
                        disabled={resultData?.length <= 0}
                        disableElevation
                        onClick={handleClickExportType}
                        startIcon={<DownloadIcon />}
                        endIcon={<KeyboardArrowDownSharp />}>
                        Export
                      </Button>

                      <StyledMenu
                        id="export-menu"
                        MenuListProps={{
                          "aria-labelledby": "export-menu-button",
                        }}
                        anchorEl={anchorEl2}
                        open={openExportType}
                        onClose={handleCloseExportType}>
                        <MenuItem
                          onClick={() => handelChallanDueReportPopup("pdf")}>
                          PDF
                        </MenuItem>
                        <MenuItem
                          onClick={() =>
                            handelChallanDueReportPopup("Excel")
                          }>
                          Excel
                        </MenuItem>
                      </StyledMenu>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Table Section */}
              <TableContainer>
                <Table aria-labelledby="tableTitle" size="medium">
                  {/* Table Head */}
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{ fontWeight: "bold", minWidth: "80px" }}
                        align="left">
                        Product Name
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", minWidth: "120px" }}
                        align="right">
                        Ordered Qty
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", minWidth: "100px" }}
                        align="right">
                        Used Qty
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", minWidth: "100px" }}
                        align="right">
                        Balance Qty
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", minWidth: "100px" }}
                        align="right">
                        Rate ₹
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", minWidth: "100px" }}
                        align="right">
                        Ordered Amount ₹
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", minWidth: "120px" }}
                        align="right">
                        Balance Amount ₹
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* Table Body */}
                  {resultData?.length > 0 ? (
                    <TableBody>
                      {stableSort(
                        resultData,
                        getComparator(order, orderBy)
                      ).map((item, index) => (
                        <TableRow key={index}>
                          <TableCell
                            align="left"
                            onClick={() =>
                              handleMoveToChallanDueDetail(item.productId)
                            }>
                            <Button
                              disableRipple
                              sx={{ justifyContent: "left" }}
                              className="manuButton-link"
                              color="primary"
                              onClick={() =>
                                handleMoveToChallanDueDetail(item?.productId)
                              }>
                              <span className="text-link">
                                {item?.productName}
                              </span>
                            </Button>
                          </TableCell>
                          <TableCell align="right">
                            {item?.orderedQuantityDisplay}
                          </TableCell>
                          <TableCell align="right">
                            {item?.usedQuantityDisplay}
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }} align="right">
                            {item?.balanceQuantityDisplay}
                          </TableCell>
                          <TableCell align="right">
                            {numberFormat(item?.rate) + " / " + item?.rateUnit}
                          </TableCell>
                          <TableCell align="right">
                            {numberFormat(item?.orderedAmount)}
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }} align="right">
                            {numberFormat(item?.balanceAmount)}
                          </TableCell>
                        </TableRow>
                      ))}

                      {/* Totals Row */}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={11} align="center">
                          No record(s) found
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>

                {/* Pagination */}
                {resultData?.length > 0 && (
                  <Grid
                    container
                    paddingTop={1}
                    alignItems="center"
                    justifyContent="center">
                    <Grid item xs={12} sm={6} className="pagination-label">
                      {pageInfo.startIndex} - {pageInfo.endIndex} of{" "}
                      {totalCount}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Stack
                        component="div"
                        alignItems={mobileScreen ? "center" : "end"}
                        justifyContent="center">
                        <Pagination
                          color="primary"
                          count={pageInfo.totalPages}
                          page={page}
                          onChange={handlePageChange}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                )}
              </TableContainer>
            </Paper>
          </Grid>
        </Box>
      ) : (
        <Box
          className="boxContainer"
          sx={{
            "& > :not(style)": {
              width: "100%",
            },
          }}>
          <MissingConsumer consumerId={userContext.consumerId} />
        </Box>
      )}
    </>
  );
}
